import React, { useContext, useEffect, useState } from 'react';
import './ProfilePage.css';
import { AuthContext } from '../contexts/AuthContext';
import NavBar from '../components/layout/NavBar';
import Footer from '../components/layout/Footer';
import { getOrders, getOrderPdf } from '../services/api';
import { formatCuit } from '../utils/utils';

function ProfilePage() {
  const { userInfo } = useContext(AuthContext);
  const token = sessionStorage.getItem('token');
  const [user, setUser] = useState({
    username: '',
    cuit: '',
    email: '',
    approve: false,
    phone: '',
  })
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (userInfo) {
      setUser(prevUser => ({
        ...prevUser,
        ...userInfo,
        approve: userInfo.approve !== undefined ? userInfo.approve : prevUser.approve,
      }));
    }
  }, [userInfo]);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const headers = { Authorization: "Token " + token };
        const data = await getOrders(headers);
        setOrders(data);
      } catch (error) {
        console.error('Error fetching orders:', error);
      }
    };

    fetchOrders();
  }, [token]);

  return (
    <div className="profile-container">
      <NavBar />
      <div className="profile-content">
        <div className="profile-div">
          <div className="profile-user">
            <h1>{user.username}</h1>
            {user.approve && <span className="material-symbols-outlined">
              verified_user
            </span>}
          </div>
          <p><b>Email</b>: {user.email}</p>
          <p><b>CUIT</b>: {formatCuit(user.cuit)}</p>
          <p><b>Teléfono</b>: {user.phone}</p>
          <p><b>Ubicación</b>: {user.location}</p>
        </div>
        <div className="orders-div">
          <h1>Órdenes</h1>
          <div className="orders-table">
            <table>
              <tr>
                <th>N°</th>
                <th>Pedido</th>
                <th>Entrega</th>
                {/* <th>Resumen</th> */}
              </tr>
              {orders.map((item) => (
                <OrderItem props={item} token={token} />
              ))}
              {!orders.length && 
              <tr>
                <td colSpan={4}>Aún no tienes pedidos</td>
              </tr>}
            </table>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}


function OrderItem({ props, token }) {
  const handleDownload = async () => {
    const headers = { Authorization: "Token " + token };
    try {
      const blob = await getOrderPdf(headers, props.id);
      const pdfUrl = URL.createObjectURL(blob);
      
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = `order-${props.id}.pdf`;
      document.body.appendChild(link);
      
      link.click();
      
      document.body.removeChild(link);
      URL.revokeObjectURL(pdfUrl);
    } catch (error) {
      console.error('Failed to fetch the PDF.', error);
    }
  };
  

  return (
    <tr>
      <td>{props.id}</td>
      <td>{props.created_at}</td>
      <td>{props.shipping_day}</td>
      {/* <td>
        <div className="order-item-button" onClick={handleDownload}>
            <span class="material-symbols-outlined">
            download
          </span>
        </div>
      </td> */}
    </tr>
  )
}

export default ProfilePage;